import React, { useCallback } from "react";
import { Grid } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";
import {
  CertaintyTextInput,
  CertaintyTextarea,
  CertaintyRichText,
} from "./CertaintyInput";

interface ConsultationFormProps {
  form: UseFormReturnType<any>;
  certainties?: Record<string, number>;
  onCertaintyChange?: (field: string, certainty: number) => void;
}

export default function ConsultationForm({
  form,
  certainties = {},
  onCertaintyChange,
}: ConsultationFormProps) {
  const handleDiagnosisChange = useCallback(
    (val: string) =>
      form.setFieldValue("case.consultationOriginalDiagnosis", val),
    [form]
  );

  const handleDiagnosisCertaintyChange = useCallback(
    (c: number) => onCertaintyChange?.("case.consultationOriginalDiagnosis", c),
    [onCertaintyChange]
  );

  return (
    <Grid gutter="md">
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <CertaintyTextarea
          label="Consultation Reason"
          placeholder="Reason for consultation"
          autosize
          minRows={2}
          maxRows={4}
          name="case.consultationReason"
          {...form.getInputProps("case.consultationReason")}
          certainty={certainties["case.consultationReason"]}
          onCertaintyChange={(c) =>
            onCertaintyChange?.("case.consultationReason", c)
          }
        />
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <CertaintyRichText
          label="Original Diagnosis"
          placeholder="Original diagnosis from referring lab (optional)"
          name="case.consultationOriginalDiagnosis"
          value={form.values.case?.consultationOriginalDiagnosis || ""}
          onChange={handleDiagnosisChange}
          certainty={certainties["case.consultationOriginalDiagnosis"]}
          onCertaintyChange={handleDiagnosisCertaintyChange}
        />
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <CertaintyTextarea
          label="Clinical Context"
          placeholder="Clinical context specific to this consultation (optional)"
          autosize
          minRows={2}
          maxRows={4}
          name="case.consultationClinicalContext"
          {...form.getInputProps("case.consultationClinicalContext")}
          certainty={certainties["case.consultationClinicalContext"]}
          onCertaintyChange={(c) =>
            onCertaintyChange?.("case.consultationClinicalContext", c)
          }
        />
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <CertaintyTextInput
          label="Requesting Pathologist"
          placeholder="Pathologist at sending lab requesting consultation (optional)"
          name="case.requestingPathologist"
          {...form.getInputProps("case.requestingPathologist")}
          certainty={certainties["case.requestingPathologist"]}
          onCertaintyChange={(c) =>
            onCertaintyChange?.("case.requestingPathologist", c)
          }
        />
      </Grid.Col>
    </Grid>
  );
}
